var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',[_c('div',{staticClass:"variants variants_offset"},[_c('div',{staticClass:"variants__container container"},[_c('div',{staticClass:"variants__inside"},[_c('div',{staticClass:"variants__heading"},[_vm._v(" Выберите продукцию TCL по модели автомобиля ")]),_c('widget-select')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }